<script setup lang="ts">
import { T } from '@tolgee/vue'
import { computed, ref, watch } from 'vue'
import { type FortuneWheelPrize } from '@/types/shared/fortune-wheel'
import CrossCircleIcon from '@/components/icons/CrossCircleIcon.vue'
import { useWatchOverlays } from '@/composables/helpers/scoll'
import { useFullScreenDimensions } from '@/composables/helpers/fullscreen'

const props = defineProps<{
  show: boolean
  prize: FortuneWheelPrize
}>()

defineEmits<{
  (e: 'hide'): void
}>()

useWatchOverlays(computed(() => props.show))
const { topStyle } = useFullScreenDimensions()

const isClickable = ref(false)

watch(() => props.show, show => {
  if (show) {
    setTimeout(() => isClickable.value = true, 500)
  } else {
    isClickable.value = false
  }
}, { immediate: true })

</script>
<template>
  <Transition
    name="fade"
    mode="out-in"
  >
    <div
      v-if="show"
      class="fixed h-screen max-h-dvh w-screen overflow-hidden left-0 bottom-0 bg-dark-most-bottom-layer/[.65] backdrop-blur-[4px] flex flex-col z-[800]"
      @click="$emit('hide')"
    >
      <CrossCircleIcon
        class="w-6 h-6 min-w-[24px] absolute top-3 right-3 text-white/[87%]"
        :style="topStyle"
      />
      <div class="h-full w-full flex-1 flex flex-col gap-y-6 items-center justify-center relative">
        <div
          class="absolute w-[334px] h-[334px] rounded-full bg-[#ABFF00] blur-[90px] -z-[1]"
        />
        <img
          class="absolute w-[334px] h-[334px] -z-[1]"
          src="@/assets/images/golden-wheel-background.png"
        >
        <div class="flex flex-col items-center">
          <h1 class="text-white text-[36px] font-bold leading-[42px] text-center max-w-[316px]">
            <T
              key-name="fortune_wheel.feathers_overlay.title"
              default-value="Congratulations!"
            />
          </h1>
        </div>

        <img
          src="@/assets/images/feather-large.png"
          class="size-[226px] rotate-[23deg]"
        >
        <div
          class="flex items-center flex-col"
        >
          <div class="text-white/[.60] text-[24px] leading-8 font-medium">
            You won
          </div>
          <div class="text-[28px] leading-8 font-bold text-light-white -tracking-[0.56px]">
            <T
              key-name="fortune_wheel.chest_prize.feathers_reward"
              default-value="{count, plural, one {# Gold Feather} other {# Gold Feathers}}"
              :params="{count: prize.amount}"
            />
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from, .fade-leave-to /* .fade-leave-active in <2.1.8 */
{
  opacity: 0;
}
</style>